import {
  loadColumnConfig,
  normalizeColumnConfig,
  resolveVisibleColumns,
  saveColumnConfig,
} from '@core/utils/table-column-config'
import TableColumnConfigDialog from '@core/components/TableColumnConfigDialog.vue'

export default {
  components: {
    TableColumnConfigDialog,
  },
  data () {
    return {
      tableColumnConfigDialogVisible: false,
      tableColumnAppliedConfig: [],
      tableColumnRenderKey: 0,
    }
  },
  created () {
    this.initTableColumnConfig()
  },
  computed: {
    activeTableColumns () {
      const columns = resolveVisibleColumns(
        this.getTableColumnDefinitions(),
        this.tableColumnAppliedConfig
      )
      return columns.filter(column => this.isTableColumnContextVisible(column))
    },
  },
  methods: {
    getTableColumnDefinitions () {
      return this.fields || []
    },
    getTableColumnStorageKey () {
      return ''
    },
    isTableColumnContextVisible (column) {
      if (!column.visibleWhen) {
        return true
      }
      if (typeof column.visibleWhen === 'function') {
        return column.visibleWhen.call(this)
      }
      if (typeof column.visibleWhen === 'string') {
        return !!this[column.visibleWhen]
      }
      return true
    },
    initTableColumnConfig () {
      const definitions = this.getTableColumnDefinitions()
      const saved = loadColumnConfig(this.getTableColumnStorageKey())
      this.tableColumnAppliedConfig = normalizeColumnConfig(definitions, saved)
    },
    openTableColumnConfigDialog () {
      this.tableColumnConfigDialogVisible = true
    },
    onTableColumnConfigSave (draft) {
      this.tableColumnAppliedConfig = _.cloneDeep(draft)
      saveColumnConfig(this.getTableColumnStorageKey(), {
        columns: this.tableColumnAppliedConfig,
      })
      this.tableColumnRenderKey += 1
      this.$message.success('列配置已保存')
    },
  },
}



// WEBPACK FOOTER //
// ./core/mixins/table-column-config.js